module.exports = __webpack_public_path__ + "media/images/location--greenbrier-e1b7de62bf99ba38725bf20ea1b96bd8.jpg";